<template>
  <div class="wrapper">
    <!-- 展示 -->
    <Table :columns="tableColumns" :data="tableData.data" @on-selection-change="selectChange" border
      style="margin-top: 20px">
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + (row._index + 1) }}
      </template>
      <template slot-scope="{ row }" slot="name">
        {{ row.storage.name }}
      </template>
      <template slot-scope="{ row }" slot="grade_name">
        <Tooltip :content="row.storage.grade_name" transfer placement="bottom" max-width="200">
          {{ row.storage.grade_name }}
        </Tooltip>
      </template>
      <template slot-scope="{ row }" slot="subject_name">
        <Tooltip :content="row.storage.subject_name" transfer placement="bottom" max-width="200">
          {{ row.storage.subject_name }}
        </Tooltip>
      </template>
      <template slot-scope="{ row }" slot="course_name" ellipsis>
        <Tooltip :content="row.storage.course_name" transfer placement="bottom" max-width="200">
          {{ row.storage.course_name }}
        </Tooltip>
      </template>
      <template slot-scope="{ row }" slot="teacher_name">
        <Tooltip :content="row.storage.teacher_name" transfer placement="bottom" max-width="200">
          {{ row.storage.teacher_name }}
        </Tooltip>
      </template>
      <template slot-scope="{ row }" slot="teacher_title">
        <Tooltip :content="row.storage.teacher_title" transfer placement="bottom" max-width="200">
          {{ row.storage.teacher_title }}
        </Tooltip>
      </template>

      <template slot-scope="{ row }" slot="original_price">
        {{ row.storage.original_price }}
      </template>
      <template slot-scope="{ row }" slot="current_price">
        {{ row.storage.current_price }}
      </template>
      <template slot-scope="{ row }" slot="remark">
        {{ row.storage.remark }}
      </template>
      <template slot-scope="{ row }" slot="count">
        <span>{{ row.is_buy == 1 ? row.finish_count : 0 }}/</span>{{ row.count }}
      </template>
      <template slot-scope="{ row }" slot="is_display">
        {{ row.storage.is_display == 2 ? '是' : '否' }}
      </template>
      <template slot-scope="{ row }" slot="is_free">
        {{ row.storage.is_free == 1 ? '是' : '否' }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button type="warning" size="small" @click="pingjia(row)">评分</Button>
        <Button type="info" size="small" v-if="row.is_buy == 1" @click="$refs.courseDetail.getDetail(row)">查看</Button>
        <Poptip v-auth="'admin/delete'" transfer confirm title="您确定要购买该录课库吗？" @on-ok="addSure(row)">
          <Button type="primary" style="margin-left:5px" v-if="row.is_buy != 1" size="small">购买</Button>
        </Poptip>
        <!-- <Poptip
          v-auth="'admin/delete'"
          transfer
          confirm
          title="您确定要删除这条数据吗？"
          @on-ok="removes(row)"
          style="margin-left: 5px"
        >
          <Button type="error" size="small">移除</Button>
        </Poptip> -->
      </template>
    </Table>
    <Page style="text-align: right; margin-top: 20px" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
    <Modal v-model="pingjiashow" title="评分" @on-cancel="pingjiashow = false" @on-ok="pingjiaOK">
      <Rate v-model="pjobj.score" :count='10'></Rate>
    </Modal>
    <courseDetail ref="courseDetail" />
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage"
  import courseDetail from "./courseDetail"
  export default {
    mixins: [indexPage],
    components: {
      courseDetail,
    },
    mounted() { },
    props: {
      reSearch: {
        type: Object,
        default: () => { },
      },
    },
    data() {
      return {
        pingjiashow: false,
        pjobj: {
          score: 0,
        },
        // 已选择数据
        selectData: [],
        // 搜索
        tableColumns: [
          {
            title: "序号",
            slot: "index",
            width: 80,
            align: "center",
            fixed: 'left',
          },
          {
            title: "名称",
            width: 240,
            slot: "name",
            align: "center",
            fixed: 'left',
          },
          {
            title: "级别",
            slot: "grade_name",
            align: "center",
            minWidth: 140,
          },
          {
            title: "科目",
            slot: "subject_name",
            align: "center",
            minWidth: 140,
          },
        //   {
        //     title: "课程",
        //     slot: "course_name",
        //     align: "center",
        //     minWidth: 140,
        //   },
          {
            title: "教师",
            slot: "teacher_name",
            align: "center",
            minWidth: 140,
          },
          {
            title: "头衔",
            slot: "teacher_title",
            align: "center",
            minWidth: 140,
          },
          { title: "原价", slot: "original_price", align: "center", minWidth: 140, },
          { title: "现价", slot: "current_price", align: "center", minWidth: 140, },

          {
            title: "课程页面",
            key: "course_id",
            align: "center",
            minWidth: 140,
            render: (h, params) => {
              return h("img", {
                attrs: {
                  src: `${process.env.VUE_APP_SERVER_DOMAIN}${params.row.storage.course_img}`,
                },
                style: {
                  width: "40px",
                },
              })
            },
          },
          { title: "备注", slot: "remark", align: "center", minWidth: 150, },
          {
            title: "操作",
            slot: "action",
            align: "center",
            minWidth: 160,
          },

        ],
        indexUrl: "/app/my_record_storage/index",
      }
    },

    methods: {
      search() {
        this.searchData = this.reSearch
      },
      // 选择框变化
      selectChange(select) {
        this.selectData = select
      },
      // 购买完调用
      addSure(row) {
        let data = { id: row.storage.id }
        this.$axios
          .post("/app/source_record_class_storage/buy", data)
          .then((res) => {
            if (res.code == 1) {
              this.$Message.success("购买成功")
              this.getData(this.tableData.current_page)
            } else {
              this.$Message.info(res.msg)
            }
          })
      },
      pingjia(row) {
        this.pingjiashow = true
        this.pjobj.storage_id = row.storage.id
        this.pjobj.type = 3
        this.pjobj.score = row.storage.self_score
      },
      pingjiaOK() {
        this.$axios.post("/app/comment/addData", this.pjobj).then((res) => {
          if (res.code == 1) {
            this.getData(this.tableData.current_page)
            this.$Message.success("评价成功")
            this.pingjiashow = false
          } else {
            this.$Message.info(res.msg)
          }
        })
      },
      // 删除课程
      removes(row) {
        this.$axios
          .delete("/app/my_record_storage/index", { id: row.id })
          .then((res) => {
            if (res.code == 1) {
              this.getData(this.tableData.current_page)
              this.$Message.success(res.msg)
            } else {
              this.$Message.info(res.msg)
            }
          })
      },
    },
  }
</script>
<style scoped lang='less'>
  ::v-deep .ivu-table-cell {
    .ivu-table-cell-slot {
      width: 100%;
    }
    .ivu-tooltip {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .ivu-tooltip-rel {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
